module.exports = __webpack_public_path__ + "static/media/no-battles.1c9eb951.png";